export default __webpack_public_path__ + "static/media/frutiger-55roman.9a4faabe.eot";